module.exports = __webpack_public_path__ + "static/access-map-a81562e2bb9eb2e9b06df6c678762905.jpg";